<template>
    <div 
        class="item"
    >
        <img 
            style="max-height: 30px; max-width: 30px"
            v-bind:src="'images/' + item.iconFileName" 
            v-bind:class="item.acquired ? '' : 'dimmed'"     
            v-on:mouseenter="showTooltip = true"
            v-on:mouseleave="showTooltip = false"
        />
        <div class="tooltip-spacer">
            <div class="item-tooltip" v-show="showTooltip">
                {{item.name}}<br />
                <small v-html="item.description" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'item',
        props: {
            item: Object
        },
        data() {
            return {
                showTooltip: false
            }
        }
    }
</script>

<style scoped>
.item {
    display: inline-block;
    position: relative;
    max-width: 40px;
    max-height: 40px;
    margin: 10px 5px;
}
.dimmed {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    opacity: .5;
}
.tooltip-spacer {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0px;
    left: 0px;
    /*transform: translate(-80px, -110%);*/
    transform: translate(0, -110%);
    z-index: 9999;
}
.item-tooltip {
    color: white;
    font-size: 16px;
    padding: 6px 8px;
    white-space: nowrap;
    background:rgba(0,100,155,.9);
    border-radius:3px;
    z-index: 9999;
}
</style>
